import axios from 'axios';
import { default as config } from '../../constants/constants';

export function setPdfViewerDocumentId(value) {
  return {
    type: 'SET_PDF_VIEWER_DOCUMENT_ID',
    payload: value
  };
}

export function setExpand(value) {
  return {
    type: 'SET_EXPAND',
    payload: value
  };
}

export function setFilterByThumbs(value) {
  return {
    type: 'SET_FILTER_BY_THUMBS',
    payload: value
  };
}

export function setSharedFilter(value) {
  return {
    type: 'SET_SHARED_FILTER',
    payload: value
  };
}

export function setMyFilter(value) {
  return {
    type: 'SET_MY_FILTER',
    payload: value
  };
}

export function setAiFilter(value) {
  return {
    type: 'SET_AI_FILTER',
    payload: value
  };
}

export function setFilters(value) {
  return {
    type: 'SET_FILTERS',
    payload: value
  };
}

export function setPdfFlags(value) {
  return {
    type: 'SET_PDF_FLAGS',
    payload: value
  };
}

export function fetchAllFlagsByDocumentUrl(
  token,
  pageStart,
  documentUrl,
  podcastUrl,
  tags,
  users,
  isMine,
  isShared,
  isAiFlags
) {
  const isAI =
    isAiFlags === undefined || isAiFlags === null ? false : isAiFlags;
  let url = '';
  if (tags?.length > 0 && users?.length > 0) {
    url = `${config.serverURL}/notes/notesPerSentence?episodeUrl=${documentUrl}&podcastUrl=${podcastUrl}&tags=${tags}&sourceUserIds=${users}`;
  } else if (tags?.length > 0 && (users === undefined || users?.length === 0)) {
    url = `${config.serverURL}/notes/notesPerSentence?episodeUrl=${documentUrl}&podcastUrl=${podcastUrl}&tags=${tags}`;
  } else if ((tags === undefined || tags?.length === 0) && users?.length > 0) {
    url = `${config.serverURL}/notes/notesPerSentence?episodeUrl=${documentUrl}&podcastUrl=${podcastUrl}&sourceUserIds=${users}`;
  } else {
    url = `${config.serverURL}/notes/notesPerSentence?episodeUrl=${documentUrl}&podcastUrl=${podcastUrl}`;
  }

  if (isMine !== undefined && isShared !== undefined) {
    url = url.concat(
      `&isMine=${isMine}&isShared=${isShared}&isAiFlags=${isAI}`
    );
  } else if (isMine !== undefined) {
    url = url.concat(`&isMine=${isMine}&isAiFlags=${isAI}`);
  } else if (isShared !== undefined) {
    url = url.concat(`&isShared=${isShared}&isAiFlags=${isAI}`);
  }

  if (pageStart !== null) {
    url = url.concat(`&pageStart=${pageStart}`);
  }
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: url
  };

  return {
    type: 'FETCH_ALL_FLAGS_BY_DOCUMENT_URL',
    payload: axios(options)
  };
}

export function setTypeFilter(value) {
  return {
    type: 'SET_TYPE_FILTER',
    payload: value
  };
}

export function setFlagFilters(value) {
  return {
    type: 'SET_FLAG_FILTERS',
    payload: value
  };
}

export function createFlagFromPlayer() {
  return {
    type: 'CREATE_FLAG_FROM_PLAYER',
    payload: true
  };
}

export function resetFlagCreationStatus() {
  return {
    type: 'RESET_FLAG_CREATION_STATUS',
    payload: false
  };
}
